import lazyLoad from 'app/shared-components/util/lazyLoad';

const BookingFlow = lazyLoad(() => import('./BookingFlow'));
const BookingConfirmation = lazyLoad(() => import('./BookingConfirmation'));

const BookingConfig = {
  routes: [
    {
      path: 'booking',
      element: <BookingFlow />
    },
    {
      path: 'booking/confirm',
      element: <BookingConfirmation />
    }
  ]
};

export default BookingConfig;
